import Button from "../../elements/button";
import "./index-cta.css";
import { whatsAppRedirect } from "../../../hooks/common";
import { RiWhatsappLine } from "react-icons/ri";

export default function CTA({
  title = "Sua próxima redação",
  titleBr = "pode ser a melhor que você já escreveu.",
  subtitle = "Dê o primeiro passo agora mesmo!",
  button = "QUERO MELHORAR MINHA REDAÇÃO",
  href = "https://wa.me/5522988592932",
}) {
  return (
    <section className="cta">
      <div className="container">
        <div className="cta-box">
          <div className="cta-logo">
            <img
              className="cta-logo"
              src="/images/logo-book.png"
              alt="Logo Bbook"
            />
          </div>

          <div className="cta-content">
            <h2>
              {title}
              <br />
              {titleBr}
            </h2>

            <p>{subtitle}</p>
          </div>

          <div className="hero-actions">
            <Button
              variant="button-light"
              onClick={whatsAppRedirect}
              target="_blank"
              rel="noreferrer"
            >
              <RiWhatsappLine /> {button}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
